import { useIntl } from "react-intl";

import { ConfluenceLogo } from "@atlaskit/logo";
import UFOSegment from "@atlassian/wac-ufo-segment";
import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import { useLocalizedHref } from "@/libraries/web-framework";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

const ConfluenceSoftwareNav = () => {
    const intl = useIntl();

    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=confluence&edition=free"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.CONFLUENCE,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });

    return (
        <UFOSegment name="confluence-pt-cfind-1234-confluenceSoftwareNav">
            <ProductPageSubNav
                productLogoUrl={useLocalizedHref("/software/confluence")}
                productLogo={<ConfluenceLogo appearance="brand" />}
                productLogoAriaLabel={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.confluence-logo",
                    defaultMessage: "Confluence logo"
                })}
                mobileCtaText={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.getitfree",
                    defaultMessage: "Get it free"
                })}
                navigationTrynowCtaText={intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.navbar.getitfree",
                    defaultMessage: "Get it free"
                })}
                mobileCtaUrl={signupLink}
                mobileCtaOnClick={openCrossFlow}
                mobileLogo={<ConfluenceLogo appearance="brand" />}
                productPageNavLinks={[
                    {
                        globalLinksKey: "features",
                        linkText: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.navbar.features",
                            defaultMessage: "Features"
                        }),
                        hasSubnav: false,
                        productKey: "confluence",
                        href: useLocalizedHref("/software/confluence/features")
                    },
                    {
                        globalLinksKey: "resources",
                        linkText: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                            defaultMessage: "Resources"
                        }),
                        hasSubnav: false,
                        productKey: "confluence",
                        href: useLocalizedHref("/software/confluence/resources")
                    },
                    {
                        globalLinksKey: "templates",
                        linkText: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.navbar.templates",
                            defaultMessage: "Templates"
                        }),
                        hasSubnav: false,
                        productKey: "confluence",
                        href: useLocalizedHref("/software/confluence/templates")
                    },
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "confluence",
                        href: useLocalizedHref("/software/confluence/pricing")
                    },
                    {
                        globalLinksKey: "enterprise",
                        linkText: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                            defaultMessage: "Enterprise"
                        }),
                        hasSubnav: false,
                        productKey: "confluence",
                        href: useLocalizedHref(
                            "/software/confluence/enterprise"
                        )
                    }
                ]}
                navigationTrynowCtaUrl={signupLink}
                navigationTrynowCtaOnClick={openCrossFlow}
                mobileLinksSections={[
                    {
                        key: "mobile-confluence",
                        mobileLinksProps: [
                            {
                                globalLinksKey: "features",
                                linkText: intl.formatMessage({
                                    id: "ConfluenceSoftwarePageTemplate.navbar.features",
                                    defaultMessage: "Features"
                                }),
                                hasSubnav: false,
                                productKey: "confluence",
                                href: useLocalizedHref(
                                    "/software/confluence/features"
                                )
                            },
                            {
                                globalLinksKey: "resources",
                                linkText: intl.formatMessage({
                                    id: "ConfluenceSoftwarePageTemplate.navbar.resources",
                                    defaultMessage: "Resources"
                                }),
                                hasSubnav: false,
                                productKey: "confluence",
                                href: useLocalizedHref(
                                    "/software/confluence/resources"
                                )
                            },
                            {
                                globalLinksKey: "templates",
                                linkText: intl.formatMessage({
                                    id: "ConfluenceSoftwarePageTemplate.navbar.templates",
                                    defaultMessage: "Templates"
                                }),
                                hasSubnav: false,
                                productKey: "confluence",
                                href: useLocalizedHref(
                                    "/software/confluence/templates"
                                )
                            },
                            {
                                globalLinksKey: "pricing",
                                linkText: intl.formatMessage({
                                    id: "ConfluenceSoftwarePageTemplate.navbar.pricing",
                                    defaultMessage: "Pricing"
                                }),
                                hasSubnav: false,
                                productKey: "confluence",
                                href: useLocalizedHref(
                                    "/software/confluence/pricing"
                                )
                            },
                            {
                                globalLinksKey: "enterprise",
                                linkText: intl.formatMessage({
                                    id: "ConfluenceSoftwarePageTemplate.navbar.enterprise",
                                    defaultMessage: "Enterprise"
                                }),
                                hasSubnav: false,
                                productKey: "confluence",
                                href: useLocalizedHref(
                                    "/software/confluence/enterprise"
                                )
                            }
                        ]
                    }
                ]}
            />
        </UFOSegment>
    );
};

ConfluenceSoftwareNav.displayName = "ConfluenceSoftwareNav";

export default ConfluenceSoftwareNav;
